import { render, staticRenderFns } from "./CityList.vue?vue&type=template&id=228357ae&scoped=true&"
import script from "./CityList.vue?vue&type=script&lang=js&"
export * from "./CityList.vue?vue&type=script&lang=js&"
import style0 from "./CityList.vue?vue&type=style&index=0&id=228357ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228357ae",
  null
  
)

component.options.__file = "CityList.vue"
export default component.exports